import Usuario from "./Usuario";

class StatusRemessaCorreio {
    constructor(
        {
            id = null,
            codigo_status = null,
            descricao = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            usuario = {},

        } = {}
    ) {
        this.id = id;
        this.codigo_status = codigo_status;
        this.descricao = descricao;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();

    }




    isAguardandoLiberacao(){
        return  parseInt(this.codigo_status) == 1;
    }

    isLiberado(){
        return  parseInt(this.codigo_status) == 2;
    }

    isEmissaoSram(){
        return  parseInt(this.codigo_status) == 3;
    }    

    isPostagemSram(){
        return  parseInt(this.codigo_status) == 4;
    }    
    
    isPublicacaoSram(){
        return  parseInt(this.codigo_status) == 5;
    }      

    isComPendencias(){
        return  parseInt(this.codigo_status) == 6;
    }         

}

export default StatusRemessaCorreio;